import MuiBox, { BoxProps as MuiBoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import React, { ElementType, forwardRef, FunctionComponent, PropsWithChildren } from "react";

const PREFIX = "Box";

const classes = {
	centerBox: `${PREFIX}centerBox`,
	growNoOverflowBox: `${PREFIX}growNoOverflowBox`,
};

const StyledMuiBox = styled(MuiBox)(({
	theme,
}) => ({
	[`&.${classes.centerBox}`]: {
		alignItems: "center",
		display: "flex",
		justifyContent: "center",
	},

	[`&.${classes.growNoOverflowBox}`]: {
		flexGrow: 1,
		overflow: "hidden",
	},
}));

export interface BoxProps extends PropsWithChildren<Omit<MuiBoxProps, "component">> {
	/** indicates if content should be centered (align and justify) */
	centerContent?: boolean;

	/** define an html element type to render box as - example "nav" - default "div" */
	component?: ElementType;

	/** indicates if content should grow to fill container without overflowing */
	growNoOverflow?: boolean;
}

const Box: FunctionComponent<BoxProps> = forwardRef((props, ref) => {
	const { centerContent, className, growNoOverflow, ...otherProps } = props;

	return (
		<StyledMuiBox
			className={`${centerContent ? classes.centerBox : ""} ${growNoOverflow ? classes.growNoOverflowBox : ""} 
				${className || ""}`}
			{...{ ref }}
			{...otherProps}
		/>
	);
});

export default Box;